import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import TableTab02 from "../../../component/molecules/tableTab02";
import ConsultingApi from "../../../api/consulting.api";

const RequiredForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabList = [
    {
      title: "사전 상담",
      link: route.consulting_form_prior,
      originLink: route.consulting_form_prior,
    },
    {
      title: "필요 서류 제출",
      link: route.consulting_form_required,
      originLink: route.consulting_form_required,
    },
  ];

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getRequiredFormList();
  }, [location]);

  const [requiredFormList, setRequiredFormList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getRequiredFormList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
        consultingStatus: "SUBMIT",
      };
      let responseData = (await ConsultingApi.getPriorFormList(data)).data.data;
      setRequiredFormList(
        responseData.content.map((item) => {
          return {
            ...item,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>{"입력폼 관리"}</TableTitle>
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                placeholder={"검색어를 입력하세요"}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.consulting_form_required}?page=1&keyword=${encodeURIComponent(
                        keyword
                      )}`,
                      { replace: true }
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.consulting_form_required}?page=1&keyword=${encodeURIComponent(
                      keyword
                    )}`,
                    { replace: true }
                  );
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <TableTab02 list={tabList} style={{ marginBottom: "20px" }} />
          <Table>
            <colgroup>
              {/* 아이디 */}
              <col width={"225px"} />
              {/* 이름 */}
              <col width={"446px"} />
              {/* 제출일 */}
              <col width={"151px"} />
              {/* 상세보기 */}
              <col width={"78px"} />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <TableText>{"아이디"}</TableText>
                </Th>
                <Th>
                  <TableText>{"이름"}</TableText>
                </Th>
                <Th>
                  <TableText style={{ textAlign: "center" }}>{"제출일"}</TableText>
                </Th>
                <Th>
                  <TableText>{"상세보기"}</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {requiredFormList.map((item, index) => {
                return (
                  <Tr key={index} style={{ height: "59px", background: "#fff" }}>
                    <Td style={{ paddingLeft: "20px" }}>
                      <TableText>{item.member?.account}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.name}</TableText>
                    </Td>
                    <Td>
                      <TableText style={{ textAlign: "center" }}>{item.submitDate ? moment(item.submitDate).format("YYYY/MM/DD") : ""}</TableText>
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(route.consulting_form_required_detail + `/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.consulting_form_required}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>
    </>
  );
};

export default RequiredForm;

const AnswerText = styled(PretendardText)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: ${(props) => (props.isAnswer ? "#636C73" : "#27BEFF")};
`;
